module.exports = __webpack_public_path__ + "img/nuvending_logo.c093af54.jpeg";